import { SpyneTrait } from "spyne";
import {
  compose,
  either,
  equals,
  filter,
  head,
  isEmpty,
  isNil,
  keys,
  not,
} from "ramda";

export class NavigationTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "nav$";
    super(context, traitPrefix);
  }

  static nav$HideNav(hideBool = true, props = this.props) {
    const delayTime = hideBool ? 500 : 0;
    const hideFn = () => props.el$.toggleClass("hide", hideBool);
    this.setTimeout(hideFn, delayTime);
  }

  static nav$OnWindowShadeEvent(e) {
    const { scrollY, scrollDir } = e.payload;
    const showHeader = scrollDir === "up" || scrollY < 50;
    //this.props.el$.toggleClass('hide-header', !showHeader);
  }

  static nav$CreateCardStateMachine() {
    let prevPageId, prevCardId;
    let prevCardIdExists = false;
    let cardState, prevCardState;

    const exists = compose(not, either(isNil, isEmpty));

    // payload is route data
    const getCurrentState = (payload) => {
      const { isDeepLink, routeData, pathsRemoved } = payload;
      const isAppLink = !isDeepLink;
      const { pageId, cardId } = routeData;
      const cardIdExists = exists(cardId);
      const isNewCard = cardIdExists && prevCardIdExists;
      const pageChanged = pageId !== prevPageId;
      const prevCardStateIsExpanded = [
        "expand",
        "reveal",
        "crossFade",
      ].includes(prevCardState);

      const expand =
        cardIdExists &&
        isAppLink &&
        prevCardStateIsExpanded === false &&
        isNewCard === false;
      const minimize =
        isAppLink &&
        prevCardStateIsExpanded &&
        isNewCard === false &&
        pageChanged === false;
      const crossFade =
        prevCardStateIsExpanded && isNewCard && pageChanged === false;
      const reveal =
        (cardId && isDeepLink) ||
        (prevCardStateIsExpanded && isNewCard && pageChanged === true);

      cardState = compose(
        head,
        keys,
        filter(equals(true)),
      )({ expand, minimize, crossFade, reveal });
      /*console.log(" CARD VARIABLES ", {
        cardState,
        cardIdExists,
        isAppLink,
        prevCardStateIsExpanded,
        isNewCard,
        prevCardIdExists,
        prevCardState,
        cardId,
        prevCardId,
        pageId,
        prevPageId,
        expand,
        minimize,
        crossFade,
        reveal,
        isDeepLink

      });*/

      const previousCardId = prevCardId;

      prevPageId = pageId;
      prevCardId = cardId;
      prevCardState = cardState;
      prevCardIdExists = cardIdExists;

      return { pageChanged, pathsRemoved, cardState, previousCardId };
    };

    return getCurrentState;
  }
}
